export default {
    namespaced: true,
    state: {
        companies: [],
    },
    getters: {
        getAll(state) {
            return state.companies;
        },
    },
    mutations: {
        setAll(state, companies) {
            Object.assign(state, {
                companies,
            });
        },
    },
    actions: {
        async fetchAll(context) {
            const companies = await context.dispatch('api/request', {
                service: 'company',
                type: 'getAll',
            }, { root: true });

            if (companies) {
                context.commit('setAll', companies);
            }
        },
    },
};
